// extracted by mini-css-extract-plugin
export default {"title_box":"datasComponent_title_box__u1-TQ","img_box":"datasComponent_img_box__xYvTd","single_img":"datasComponent_single_img__PYIIK","btn":"datasComponent_btn__w6T2W"};